import { IsProd } from "@/constants/config";
import { FlightItem } from "@/typings";
import request from "@/utils/request";

import { ApiRoutesItem } from "./routes";
import { transformFlightData } from "./transformData";

const PATH_PREFIX = IsProd ? "/v1/" : "/vb/";

interface DateRange {
  from: string;
  to: string;
}

interface Origins {
  countries: string[];
  regions: string[];
  airports: string[];
}

interface Stops {
  operator: string;
  value: number;
}

export interface GetRoutesFlightsParams {
  program?: string[];
  stops?: Stops;
  max_points?: Stops;
  tax?: Stops;
  duration?: Stops;
  origins?: Origins;
  arrivals?: Origins;
  cabin?: string[];
  date_range?: DateRange;
  page: number;
  page_size: number;
}

export const getRoutesFlights = async (data: GetRoutesFlightsParams) => {
  const res = await request.post(PATH_PREFIX + "routes_flights", {
    ...data,
  });

  const result = transformFlightData(res.data);

  return {
    data: result,
    is_last_page: res.is_last_page,
  };
};

export const getRoutesFlightsCount = (data: GetRoutesFlightsParams) => {
  return request.post(PATH_PREFIX + "routes_flights_count", {
    ...data,
  });
};

export const getRoutesFlightsCashRate = (data: GetRoutesFlightsParams) => {
  return request.post(PATH_PREFIX + "routes_flights_cash_rate", {
    ...data,
  });
};

export const searchPanoramaRefresh = (data: { search_key: string }) => {
  return request.post<void, { data: FlightItem[]; route_info: ApiRoutesItem[] }>(
    "search_panorama_refresh-" + Math.trunc(Math.random() * 300),
    {
      ...data,
    }
  );
};

export const getNotUpdatedPanorama = async () => {
  const res = await request.post<void, { data: string[] }>(PATH_PREFIX + "routes_nu_programs", {});
  return res.data;
};
